<template>
    <div class="product-info" v-if="shorex&&shorex.id>0">
        <div class="product-title">皇家常规游（免费赠送）</div>
        <div class="product-shorexes" v-for="(trip, i) in shorex.shorexTrips" :key="('shorexTrip_'+i)">
                <div class="product-shorex-title">{{trip.tripName}} - 时长约{{trip.tripTime}}小时</div>
                <div class="product-shorex-description" v-html="trip.description">
                </div>
        </div>
        <div class="product-shorex-tips">
            <p>注：</p>
            <p >
                <span class="parah-num">1)</span>预订船票时，将为您自动选中皇家常规游行程（免费）；船票支付成功后，可选择升级精品游服务。
                <!-- <span v-if="payShorexCount==0">预订船票时，将为您自动选中皇家常规游行程（免费）。</span>
                <span v-if="payShorexCount>0">预订船票时，将为您自动选中皇家常规游行程（免费）；船票支付成功后，可选择升级精品游服务。</span> -->
            </p>
            <p><span class="parah-num">2)</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</p>
            <p><span class="parah-num">3)</span>目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</p>
        </div>
    </div>
    <div class="product-info noShorex" v-else-if="payShorexCount>0">
        <div class="product-title">岸上观光服务</div>
        <div class="product-shorex-tips">
            <p>注：本航次目前暂无皇家赠送岸上观光常规游，建议您提前安排靠港日活动，或在船票支付成功后，选择升级精品游服务。</p>
        </div>
    </div>
    <div class="product-info noShorex" v-else>
        <div class="product-title">岸上观光服务</div>
        <div class="product-shorex-tips">
            <p>很抱歉，该航次岸上观光服务尚未开放选定，选定开放后，我们会在第一时间以短信的方式通知您，您也可以密切关注皇家加勒比官方网站。</p>
        </div>

    </div>
</template>

<script>
export default {
    name: "GuestInfoShorex",
    computed: {
        order () {
            return this.$store.state.booking.order
        },
        shorex () {
            if (!this.order || !this.order.shorex) {
                return {}
            }
            return this.order.shorex
        },
        payShorexCount () {
            if (!this.order) return 0
            return this.order.payShorexCount || 0
        }
    }
}
</script>

<style lang="less" scoped>
.product-info {
    //width: 841px;
    background: #fff;
    vertical-align: 2px;
    margin-bottom: 10px;
    padding: 22px 22px 30px;
    color: #747d80;
    .product-title {
        font-size: 22px;
        letter-spacing: 1px;
        color: #282b2c;
        
    }
    .product-shorexes {
        border-bottom: solid 1px #DEE3E5;
        .product-shorex-title {
            font-size: 16px;
            font-weight: 600;
            color: #282b2c;
            border-left: solid 3px #54A3DE;
            height: 16px;
            line-height: 16px;
            padding-left: 5px;
            margin: 20px 0;
        }
        .product-shorex-description {
            padding-bottom: 20px;
            font-size: 14px !important;
            font-weight: 600 !important;
            color: #282b2c;
            margin-bottom: 0px;
        }
    }
    .product-shorex-tips {
        padding-top: 22px;
        color: #747d80;
        p {
            margin-bottom: 0px;
        }
    }
    .parah-num {
        display: inline-block;
        width: 20px;
    }
    
}
.noShorex {
    padding-bottom: 10px !important;
    .product-shorex-tips {
        padding-top: 0px;
    }
}
</style>

<style lang="less">
.product-info .product-shorexes .product-shorex-description {
    p, span {
        font-size: 14px !important;
    }
}
</style>